import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "../Layouts/PageLayout";
import { decodeID, encodeID, getLastURL } from "../../utils/Helper";
import { SubscriptionPlanDetailsAction } from "../../Redux/Action/SubscriptionPlanAction";
import { url } from "../../Config/Config";
import { FormattedMessage, useIntl } from "react-intl";

function SubscriptionPlanView() {
  const dispatch = useDispatch<any>();
  const intl = useIntl();
  const log_in = useSelector((state: any) => state.AdminLogInState);
  const plan = useSelector((state: any) => state.SubscriptionPlanDetailsState?.data?.data);
  const location = useLocation();
  const editId = getLastURL(location);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      SubscriptionPlanDetailsAction({
        detail_id: decodeID(editId),
      }),
    );
    setTimeout(() => setLoading(false), 400);
  }, [dispatch, editId]);

  return (
    <Fragment>
      {loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={intl.formatMessage({ id: "subscription_plan_details" })}
        breadcrumbs={{
          secLast: { link: "/subscription-plans", name: intl.formatMessage({ id: "subscription_plans" }) },
        }}
        buttons={[
          {
            url: `${url}/subscription-plan-edit/${encodeID(plan?.id)}`,
            className: "btn btn-primary me-2",
            text: intl.formatMessage({ id: "edit" }),
            show: !!plan?.id,
          },
        ]}
      >
        <div className="card">
          <div className="card-body">
            <div className="row gy-4">
              <div className="col-md-6">
                <label className="form-label text-muted"><FormattedMessage id="subscription_name" /></label>
                <p className="mb-0">{plan?.name ?? "—"}</p>
              </div>
              <div className="col-md-6">
                <label className="form-label text-muted"><FormattedMessage id="plan_code_label" /></label>
                <p className="mb-0">{plan?.plan_code ?? "—"}</p>
              </div>
              <div className="col-12">
                <label className="form-label text-muted"><FormattedMessage id="subscription_overview" /></label>
                <p className="mb-0">{plan?.overview ?? "—"}</p>
              </div>
              <div className="col-md-4">
                <label className="form-label text-muted"><FormattedMessage id="subscription_price" /></label>
                <p className="mb-0">
                  {plan?.price != null ? Number(plan.price).toFixed(2) : "—"}
                </p>
              </div>
              <div className="col-md-4">
                <label className="form-label text-muted"><FormattedMessage id="subscription_validity" /></label>
                <p className="mb-0">
                  {plan?.validity_days != null
                    ? intl.formatMessage({ id: "days_count" }, { count: plan.validity_days })
                    : "—"}
                </p>
              </div>
            </div>

            <hr className="my-4" />
            <h5 className="mb-3"><FormattedMessage id="subscription_features" /></h5>
            <ul className="list-unstyled small text-start">
              <li className="mb-2">
                <strong><FormattedMessage id="services_management_label" /></strong>{" "}
                {plan?.max_services == null
                  ? intl.formatMessage({ id: "unlimited_services" })
                  : intl.formatMessage({ id: "up_to_services_admin_configurable" }, { count: plan.max_services })}
              </li>
              <li className="mb-2">
                <strong><FormattedMessage id="staff_management_label" /></strong>{" "}
                {plan?.max_staff == null
                  ? intl.formatMessage({ id: "unlimited_staff_members" })
                  : intl.formatMessage({ id: "up_to_staff_admin_configurable" }, { count: plan.max_staff })}
              </li>
              <li className="mb-2">
                <strong><FormattedMessage id="offline_bookings_label" /></strong>{" "}
                {plan?.max_offline_booking_staff == null
                  ? intl.formatMessage({ id: "offline_bookings_all_staff" })
                  : intl.formatMessage(
                      { id: "offline_bookings_up_to_staff" },
                      { count: plan.max_offline_booking_staff },
                    )}
              </li>
              <li className="mb-2">
                <strong><FormattedMessage id="growth_statistics_label" /></strong>{" "}
                {plan?.enable_growth_statistics
                  ? intl.formatMessage({ id: "growth_statistics_desc" })
                  : intl.formatMessage({ id: "disabled_for_this_plan" })}
              </li>
              <li className="mb-2">
                <strong><FormattedMessage id="appointment_cancellation_label" /></strong>{" "}
                {plan?.enable_appointment_cancellation
                  ? intl.formatMessage({ id: "cancel_all_upcoming_appointments" })
                  : intl.formatMessage({ id: "disabled_for_this_plan" })}
              </li>
            </ul>

            <Link to={`${url}/subscription-plans`} className="btn btn-light mt-2">
              <FormattedMessage id="back_to_list" />
            </Link>
          </div>
        </div>
      </PageLayout>
    </Fragment>
  );
}

export default SubscriptionPlanView;
